module.exports = __webpack_public_path__ + "img/costco.f6fda600.jpg";